import {Component} from '@angular/core';
import {AlertController, Platform} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {NavService} from 'shared/nav/nav.service';

import {environment} from 'environment';

import { App } from '@capacitor/app';
import { UserService } from 'app/profile/services/user.service';
import { UserProfile } from 'app/profile/model/model';
import { LocalSettingsService } from 'shared/local-settings/local-settings.service';
import { InstructionComponent } from 'shared/components/instruction/instruction.component';
import { HyphenateService } from 'shared/helpers/hyphenate.service';

@Component({
  selector: 'dev-options-page',
  templateUrl: 'dev-options-page.html',
  styleUrls: ['dev-options-page.scss'],
})
export class DevOptionsPage {

  public appVersion: string;
  public appBuild: string;
  public buildTime: string;
  public platforms: string;

  public profile: UserProfile;

  public contentImmediately: boolean;
  public ep_monday: boolean;
  public ep_friday: boolean;

  constructor(
    public navService: NavService,
    private platform: Platform,
    private translateService: TranslateService,
    private alertCtrl: AlertController,
    private userService: UserService,
    private localSettingsService: LocalSettingsService,
    private hyphenateService: HyphenateService,

  ) {
    if (this.platform.is('capacitor')) {
      App.getInfo().then((appInfo) => {
        this.appVersion = appInfo.version;
        this.appBuild = appInfo.build;
      });
    }
    this.buildTime = environment.timeStamp;
    this.platforms = this.platform.platforms().join(', ');
  }

  private ionViewWillEnter(): void {
    this.userService.getUserProfile('full')
      .subscribe((profile: UserProfile) => {
        this.profile = profile;
      });
      this.contentImmediately = this.userService.getDevContentImmediately();
      this.ep_monday = this.userService.getDevEpisodes() == 'MONDAY';
      this.ep_friday = this.userService.getDevEpisodes() == 'FRIDAY';
    }
  // tslint:disable-next-line:no-empty

  public get targetGroup(): string {
    return this.hyphenateService.getTargetGroup();
  }
  
  public get kontrollGroup(): string {
    return this.userService.isKontrollGroupCached() ? "yes" : "no";
  }

  public resetMorningInteraction(): void { }

  // tslint:disable-next-line:no-empty
  public resetNightInteraction(): void { }

  private onInteractionResetSuccess(morning: boolean): void {
    const title: string = `DEV_OPTIONS.${morning ? 'RESET_MORNING_INTERACTION' : 'RESET_NIGHT_INTERACTION'}`;
    this.showTranslatedMessage(title, 'DEV_OPTIONS.ACTION_SUCCESS', 'COMMON.OK');
  }

  private onInteractionResetError(morning: boolean): void {
    const title: string = `DEV_OPTIONS.${morning ? 'RESET_MORNING_INTERACTION' : 'RESET_NIGHT_INTERACTION'}`;
    this.showTranslatedMessage(title, 'DEV_OPTIONS.ACTION_ERROR', 'COMMON.OK');
  }

  public onOnboarding(): void {
    this.navService.root('login', {devOnboarding: true});
  }

  public onResetInstructions() {
    this.localSettingsService.delByPrefix(InstructionComponent.INS_PREFIX);
  }

  public onModeInitial(): void {
    this.navService.root('login/mode');
  }

  public setContentImmediately() {
    this.userService.setDevContentImmediately(this.contentImmediately);
  }

  public setEpisodes(val: boolean, type: string) {
    if ( val ) {
      if ( type == 'MONDAY') {
        this.ep_friday = false;
      }
      else {
        this.ep_monday = false;
      }
    }
    if ( val ) {
      this.userService.setDevEpisodes(type);
    }
    setTimeout(() => {
      if (!this.ep_monday && !this.ep_friday) {
         this.userService.setDevEpisodes('');
      }
    });
  }

  private showTranslatedMessage(title: string, description: string, button: string): void {
    this.translateService.get([
      title,
      description,
      button,
    ]).subscribe(async(translations) => {
      const titleLabel: string = translations[title];
      const descriptionLabel: string = translations[description];
      const okLabel: string = translations[button];

      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        header: titleLabel,
        message: descriptionLabel,
        buttons: [
          {
            text: okLabel,
          },
        ],
      });
      alert.present();
    });
  }
}
